import { PlusIcon } from "../../Icons"
import '../index.css'

interface AddChipProps {
  onClick?: () => void
  label?: string
  disabled?: boolean
}

const AddChip: React.FC<AddChipProps> = ({ onClick, label, disabled }) => {

  return (
    <div>
      <button disabled={disabled} className="chip-btn" onClick={onClick}>
        <PlusIcon className="chip-btn__icon" />
        {label}
      </button>
    </div>
  )
}

export default AddChip